import Const from 'const';
import {calcValByPct} from 'helpers/common-helper';
import NumberHelper from 'helpers/number-helper';
import {ItemStructureInterface} from 'src/components/organisms/range-of-outcomes/range-of-outcomes-by-positions/item-structure-interface';

export class RangeLimits {
    private max: number;

    constructor(sport: string) {
        sport = sport.toLowerCase();

        if (!Const.RANGES_OF_OUTCOMES.hasOwnProperty(sport)) {
            throw new Error(`Max range of outcomes limit is absent for sport "${sport}"`);
        }

        this.max = Const.RANGES_OF_OUTCOMES[sport];
    }

    getMin(): number {
        return 0;
    }

    getMax(): number {
        return this.max;
    }
}

export function calcRangeOfOutcomesValue(baseValue: number, rangeOfOutcomesPct: number): number {
    const outcome = calcValByPct(baseValue, rangeOfOutcomesPct, 2);

    if (0 < outcome) {
        const min: number = NumberHelper.float(baseValue - outcome, 3);
        const max: number = NumberHelper.float(baseValue + outcome, 3);
        const randomValue = NumberHelper.getRandomInt(min, max, false);

        return NumberHelper.float(randomValue, 3);
    }

    return baseValue;
}

export function getRandomisationValuePtc(rangeOfOutcomes, sportConfig, lineupsQuantity): number {
    if (!rangeOfOutcomes.isDefaultValue()) {
        return rangeOfOutcomes.getRangeOfOutcomes();
    }

    if (isNeedToUseForcedRangeOfOutcomesPct(lineupsQuantity.getLineupsQuantity())) {
        return getForcedRangeOfOutcomesPct(sportConfig.getSite());
    }

    return rangeOfOutcomes.getRangeOfOutcomes();
}

export function getRandomisationByPositionsValuePtc(
    rangeOfOutcomesByPositions,
    sportConfig,
    lineupsQuantity,
): ItemStructureInterface[] {
    if (!rangeOfOutcomesByPositions.isDefaultValue()) {
        return filterItemsByRangeOfOutcomesPct(rangeOfOutcomesByPositions.getAllAsArr());
    }

    const forcedRangeOfOutcomesPct = getForcedRangeOfOutcomesPct(sportConfig.getSite());

    if (forcedRangeOfOutcomesPct > 0 && isNeedToUseForcedRangeOfOutcomesPct(lineupsQuantity.getLineupsQuantity())) {
        return generateForcedRangeOfOutcomesByPositions(forcedRangeOfOutcomesPct);
    }

    return filterItemsByRangeOfOutcomesPct(rangeOfOutcomesByPositions.getAllAsArr());
}

function filterItemsByRangeOfOutcomesPct(items: ItemStructureInterface[]): ItemStructureInterface[] {
    return items.filter((item) => item.value > 0);
}

function getForcedRangeOfOutcomesPct(siteName: string): number {
    if (siteName.toLowerCase() === Const.SITE_DK) {
        return Const.DRAFTKINGS_FORCED_RANGE_OF_OUTCOMES_PTC;
    }

    return Const.RANGES_OF_OUTCOMES_COMMON_DEFAULT_VALUE;
}

function isNeedToUseForcedRangeOfOutcomesPct(lineupsQuantityValue: number): boolean {
    return lineupsQuantityValue >= Const.LINEUPS_QUANTITY_FOR_USING_FORCED_RANGE_OF_OUTCOMES_PTC;
}

function generateForcedRangeOfOutcomesByPositions(forcedRangeOfOutcomesPct: number): ItemStructureInterface[] {
    const positionsMap: string[][] = Object.values(Const.MLB_POSITIONS_MAP);

    return positionsMap.map((positions) => {
        return {
            positions,
            value: forcedRangeOfOutcomesPct,
        };
    });
}
